<template>
  <div class="html-editor-modal">
    <HMModalHeader :title="title" @close="$emit('close')" />
    <form @submit.prevent="save">
      <div class="editor-container mb-4">
        <div class="inner-editor-container">
          <editor
            ref="editor"
            :config="editorJsConfig"
            :initialized="onEditorInitialized"
          />
        </div>
      </div>
      <HMModalFooter
        :submitButton="$t('GENERAL.BUTTON.SAVE')"
        :disabled="inProgress"
        :loading="inProgress"
        @close="$emit('close')"
      />
    </form>
  </div>
</template>

<script>
import editorJsConfig from '@/web/utils/editorjs-config';
import { convertAlignableParagraphToParagraph } from '@/core/utils/utils';
import Undo from 'editorjs-undo';

export default {
  name: 'HMHTMLEditorModal',
  props: {
    value: {
      type: String,
    },
    htmlValue: {
      type: String,
    },
    title: {
      type: String,
      default: '',
    },
    onUpdate: null,
  },
  computed: {
    convertedValue() {
      return convertAlignableParagraphToParagraph(this.value);
    },
    editorJsConfig() {
      if (this.value) {
        return {
          ...editorJsConfig,
          data: JSON.parse(this.convertedValue),
        };
      } else {
        return {
          ...editorJsConfig,
          data: {
            blocks: [
              {
                type: 'paragraph',
                data: {
                  text: '',
                },
              },
            ],
          },
        };
      }
    },
  },
  data() {
    return {
      editor: null,
      inProgress: false,
    };
  },
  methods: {
    async onEditorInitialized(editor) {
      this.editor = editor;
      await editor.isReady;
      if (this.value) {
        // The value will be passed in via the computed property
        // await editor.blocks.render(this.value)
      } else {
        if (this.htmlValue) {
          await editor.blocks.renderFromHTML(this.htmlValue);
        }
      }
      new Undo({ editor });
    },
    async save() {
      const jsonData = await this.editor.save();
      await this.onUpdate(jsonData);
      this.$emit('close');
    },
  },
  destroyed() {
    if (this.editor) {
      this.editor.destroy();
    }
  },
};
</script>

<style scoped></style>
